<template>
    <div>
        <v-layout>
            <v-flex xs12 sm8 offset-sm2 style="padding: 10px; padding-top: 20px">
                <card class="z-depth-1">
                    <v-card-media :src="require('../assets/photovoltaic.jpg')" height="200px">
                    <v-layout column style="width: 100%; height: 100%">
                        <v-spacer></v-spacer>
                        <v-flex>
                            <div style="width: 100%; font-weight: bold; text-align: center;">
                                <h1 style="font-weight: bold; font-size: 300%; color: white; text-shadow: 0 0 5px black;">Planungsbüro für Energieanlagen</h1>
                            </div>
                    </v-flex>
                    </v-layout>
                    </v-card-media>
                    <card-body>
                        <v-layout>
                            <v-flex xs6 style="padding: 35px">
                                <div class="view zoom z-depth-2">
                                    <img class="img-fluid" src="../assets/AIR_BHKWII/BHKWII.jpg" alt="placeholder.">
                                    <div class="mask flex-center" @mouseover="hovered = true" @mouseleave="hovered = false">
                                        <h4 class="white-text" v-if="hovered">BHKW II - Airbus</h4>
                                    </div>
                                </div>
                            </v-flex>
                            <v-flex xs6>
                                <v-container fill-height>
                                    <v-layout row wrap align-center>
                                        <v-flex xs12>
                                            <h4 class="card-title" style="text-align: center; font-weight: bold; color: #112f6b">Kraftwerkstechnik</h4>
                                            <v-list>
                                                <v-list-tile avatar v-for="item in content.kraftwerktechnik" :key="item.text">
                                                    <v-list-tile-action>
                                                        <v-icon>keyboard_arrow_right</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-content style="text-overflow: ellipsis" v-text="item.text"></v-list-tile-content>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </v-list>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout>
                            <v-flex xs6>
                                <v-container fill-height>
                                    <v-layout row wrap align-center>
                                        <v-flex xs12>
                                            <h4 class="card-title" style="text-align: center; font-weight: bold; color: #112f6b">Gesamtplanung von BHKWs</h4>
                                            <v-list>
                                                <v-list-tile avatar v-for="item in content.bhkw" :key="item.text">
                                                    <v-list-tile-action>
                                                        <v-icon>keyboard_arrow_right</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-content style="text-overflow: ellipsis" v-text="item.text"></v-list-tile-content>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </v-list>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>
                            <v-flex xs6 style="padding: 35px">
                                <div class="text-center view zoom z-depth-2">
                                    <img class="img-fluid" src="../assets/ITZ_Klosterforst/klosterforst.jpg" alt="placeholder.">
                                    <div class="mask flex-center" @mouseover="hovered2 = true" @mouseleave="hovered2 = false">
                                        <h4 class="white-text" v-if="hovered2">BHKW Klosterforst - Stadtwerke Itzehoe</h4>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout>
                            <v-flex xs6 style="padding: 35px">
                                <div class="text-center view zoom z-depth-2">
                                    <img class="img-fluid" src="../assets/AIR_BHKWI/BHKWI.jpg" alt="placeholder.">
                                    <div class="mask flex-center" @mouseover="hovered3 = true" @mouseleave="hovered3 = false">
                                        <h4 class="white-text" v-if="hovered3">BHKW I - Airbus</h4>
                                    </div>
                                </div>
                            </v-flex>
                            <v-flex xs6>
                                <v-container fill-height>
                                    <v-layout row wrap align-center>
                                        <v-flex xs12>
                                            <h4 class="card-title" style="text-align: center; font-weight: bold; color: #112f6b">Weitere Leistungen</h4>
                                        </v-flex>
                                        <v-list>
                                            <v-list-tile avatar v-for="item in content.leistungen" :key="item.text">
                                                <v-list-tile-action>
                                                    <v-icon>keyboard_arrow_right</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-content style="text-overflow: ellipsis" v-text="item.text"></v-list-tile-content>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                    </v-layout>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </card-body>
                </card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import card from '@/components/Card';
    import cardHeader from '@/components/CardHeader';
    import cardBody from '@/components/CardBody';
    export default {
        components:{
            'Card': card,
            'CardHeader': cardHeader,
            'CardBody': cardBody,
        },
        data () {
            return {
                content: {
                    kraftwerktechnik: [
                        {text: "Analyse vorhandener Kraftwerksanlagen und Optimierung gegen Marktstrukturen"},
                        {text: "Entwicklung von Repowering-Konzepten"},
                        {text: "Machbarkeitsstudien für Neuanlagen"},
                    ],
                    bhkw: [
                        {text: "Entwurfsplanung"},
                        {text: "Erstellung von Genehmigungsanträgen"},
                        {text: "Ausschreibungsunterlagen"},
                        {text: "Projektabwicklung"}
                    ],
                    leistungen: [
                        {text: "Ausstellung von Primärenergie-Bescheinigungen (Gutachter nach FW 609)"},
                        {text: "Ausstellung von Bescheinigungen des Erfüllungsgrades nach GEG"},
                    ]
                },
                hovered: false,
                hovered2: false,
                hovered3: false,
            };
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/subpages/services.vue